import { useCallback, useState } from 'react';
import useNavigateToDeliveryDetailPage from 'hooks/useNavigateToDeliveryDetailPage';
import { DeliveryStatus } from 'api/models/Deliveries';
import { useIsTierZero } from './useSubscriptionTier';
import { useIsHospitalViewer } from './useIsHospitalViewer';

export const useDeliveryClickHandler = () => {
  const isTierZero = useIsTierZero();
  const { isHospitalViewer } = useIsHospitalViewer();

  const [activeDeliveryForCheckInDeliveryDialog, setActiveDeliveryForCheckInDeliveryDialog] = useState<number | null>(
    null,
  );

  const navigateToDeliveryDetailPage = useNavigateToDeliveryDetailPage();

  const handleDeliveryClick = useCallback(
    (deliveryId: number, deliveryStatus: DeliveryStatus, hasMissingFields = false) => {
      if (
        !isTierZero &&
        // hospital viewers are read-only, so never offer to start check-in
        !isHospitalViewer &&
        (deliveryStatus === 'RECEIVED' || deliveryStatus === 'PARTIALLY_CHECKED_IN') &&
        !hasMissingFields
      ) {
        setActiveDeliveryForCheckInDeliveryDialog(deliveryId);
      } else {
        navigateToDeliveryDetailPage(deliveryId, deliveryStatus);
      }
    },
    [isHospitalViewer, isTierZero, navigateToDeliveryDetailPage],
  );

  return { activeDeliveryForCheckInDeliveryDialog, handleDeliveryClick, setActiveDeliveryForCheckInDeliveryDialog };
};
